var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":_vm.id,"readonly":_vm.readonly},domProps:{"value":_vm.viewValue},on:{"focus":_vm.selectAll,"input":_vm.onInput,"blur":_vm.onBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }